module.exports = __webpack_public_path__ + "static/media/teresa-esguerra.6d0bdc32.jpg";